var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExitFullScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.5a1 1 0 011 1V15a.5.5 0 01-1 0v-2.792L.854 15.854a.5.5 0 11-.708-.708l3.647-3.645L1 11.5a.5.5 0 01-.492-.41L.5 11a.5.5 0 01.5-.5h3.5zm10.5 0a.5.5 0 010 1h-2.794l3.648 3.646a.5.5 0 11-.708.708L11.5 12.208V15a.5.5 0 01-.41.492L11 15.5a.5.5 0 01-.5-.5v-3.5a1 1 0 011-1H15zM15.854.146a.5.5 0 010 .708L12.208 4.5H15a.5.5 0 01.492.41L15.5 5a.5.5 0 01-.5.5h-3.5a1 1 0 01-1-1V1a.5.5 0 011 0v2.794L15.146.146a.5.5 0 01.708 0zm-15 0L4.5 3.794V1a.5.5 0 01.41-.492L5 .5a.5.5 0 01.5.5v3.5a1 1 0 01-1 1H1a.5.5 0 010-1h2.792L.146.854A.5.5 0 11.854.146z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullScreen);
export default __webpack_public_path__ + "static/assets/exit-full-screen.ea7fe857.svg";
export { ForwardRef as ReactComponent };